class FacetFiltersForm extends HTMLElement {
    constructor() {
      super();
      this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
      this.pillsSlider(document.querySelector('.facets-container swiper-slider'));

      this.debouncedOnSubmit = debounce((event) => {
        if(event.target.classList.contains('search-input')) {
          this.handleBrandSearch(event)
        } else {
          let searchParamsArr = JSON.parse(sessionStorage.getItem('searchParams')) ? JSON.parse(sessionStorage.getItem('searchParams')) : [];
          if(searchParamsArr.indexOf(event.target.value) > -1) {
            const index = searchParamsArr.indexOf(event.target.value);
            searchParamsArr.splice(index, 1);
          } else {
            searchParamsArr.push(event.target.value);
          }
          sessionStorage.removeItem('searchParams')
          sessionStorage.setItem('searchParams', JSON.stringify(searchParamsArr))
          this.onSubmitHandler(event);
        }
      }, 200);

      const facetForm = this.querySelector('form');
      facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

      const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
      if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

      this.initEvents();

      if(Shopify.locale == 'it') {
        this.translateLabels();
      }

      /* document.addEventListener("DOMContentLoaded", ()=>{
        FacetFiltersForm.handleFilterCategory(window.location.search);
      }) */
    }


    initEvents() {
      const buttonExpand = this.querySelector('.mobile-facets__button--expand');
      if(buttonExpand) buttonExpand.addEventListener('click', function(event) {
        const prevElem = event.target.previousElementSibling;
        prevElem.classList.contains('expanded') ? prevElem.classList.remove('expanded') : prevElem.classList.add('expanded')
      });

      // Fetch all the details element.
      const details = this.querySelectorAll("details summary");

      // Add the onclick listeners.
      details.forEach((targetDetail) => {
        targetDetail.addEventListener("click", () => {
          // Close all the details that are not targetDetail.
          if(targetDetail.parentElement.hasAttribute('open')) {
            this.querySelector('form').classList.remove('submenu-open')
          } else {
            this.querySelector('form').classList.add('submenu-open')
          }
        });
      });

      window.addEventListener(
        "page-update",
        (e) => {

          if(Shopify.locale == 'it') {
            if(this.allResults && Object.keys(this.allResults).length > 0) {

              Object.entries(this.allResults).forEach(([key, value]) => {

                if(this.querySelector("[data-value='" + key.toLowerCase() + "']")) {
                  this.querySelector("[data-value='" + key.toLowerCase() + "'] span").innerHTML = value
                }

                if(this.querySelector("[data-fv='" + key.toLowerCase() + "']")) {
                  this.querySelector("[data-fv='" + key.toLowerCase() + "']").innerHTML = value
                }
              });
            } else {
              this.translateLabels()
            }
          }
        },
        false
      );
    }

    pillsSlider(slider) {

      if (typeof Swiper !== 'undefined' && slider) {

        const swiperElement = slider.querySelector(".pills.swiper");

        if (swiperElement) {
          const overlay = slider.querySelector(".opacity-component");

          const swiperPills = new Swiper(swiperElement, {
            slidesPerView: "auto",
            loop: false,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }
          });

          if (swiperPills.isEnd && !overlay.classList.contains("hide")) {
            overlay.classList.add("hide");
          }

          swiperPills.on('reachEnd', () => {
            if (!overlay.classList.contains("hide")) {
              overlay.classList.add("hide");
            }
          });

          swiperPills.on("transitionEnd", () => {
            if (!swiperPills.isEnd && overlay.classList.contains("hide")) {
              overlay.classList.remove("hide");
            }
          });
        }
      }
    }

    translateLabels() {
      window.addEventListener('DOMContentLoaded', () => {
        const filtersData = this.dataset.filters;
        const allFetchRequests = [];
        this.allResults = {}
        const self = this;
        if(filtersData != undefined) {
          const filters = JSON.parse(filtersData)

          filters.forEach(elem => {
            Object.keys(elem).forEach(function(key) {
              if(key != 'color') {
                let filterKey = key
                /* Filter label is different from metafield key */
                switch (key) {
                  case 'type':
                    filterKey = 'grupposuper'
                    break;
                    case 'category':
                      filterKey = 'gruppo'
                      break;
                    case 'subcategory':
                      filterKey = 'sub-gruppo'
                    break;
                    case 'bag dimension':
                      filterKey = 'bag-dim'
                    break;
                    case 'skirt style':
                      filterKey = 'skirt-style'
                    break;
                    case 'knitwear style':
                      filterKey = 'knitwear-style'
                    break;
                    case 'dress style':
                      filterKey = 'dress-style'
                    break;
                }

                let fetchUrl = '/it/collections/all?view=ajax-filters&filter.p.m.elastick.';
                const filterUrl = fetchUrl + filterKey.replace(' ', '') + '=' + encodeURIComponent(elem[key])

                const fetchReq = fetch(filterUrl
                ).then((res) => res.json())
                .then(res => {
                  if(self.querySelector("[data-fv='" + elem[key].toLowerCase() + "']")) {
                    self.querySelector("[data-fv='" + elem[key].toLowerCase() + "']").innerHTML = res
                  }
                  if(self.querySelector("[data-value='" + elem[key].toLowerCase() + "']")) {
                    self.querySelector("[data-value='" + elem[key].toLowerCase() + "'] span").innerHTML = res
                  }
                  const objkey = elem[key].toLowerCase()
                  self.allResults[objkey] = res
                })

                allFetchRequests.push(fetchReq)
              }
            })
          });
        }
      })
    }

    async fetchURLs(allFetchRequests) {
      try {
        // Promise.all() lets us coalesce multiple promises into a single super-promise
        await Promise.all(allFetchRequests);
      } catch (error) {
        console.log(error);
      }
    }

    static setListeners() {
      const onHistoryChange = (event) => {
        const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
        if (searchParams === FacetFiltersForm.searchParamsPrev) return;
        FacetFiltersForm.renderPage(searchParams, null, false);
      }

      window.addEventListener('popstate', onHistoryChange);
    }

    static toggleActiveFacets(disable = true) {
      document.querySelectorAll('.js-facet-remove').forEach((element) => {
        element.classList.toggle('disabled', disable);
      });
    }

    static renderPage(searchParams, event, updateURLHash = true) {
      FacetFiltersForm.searchParamsPrev = searchParams;
      const sections = FacetFiltersForm.getSections();
      const countContainer = document.getElementById('ProductCount');
      const countContainerDesktop = document.getElementById('ProductCountDesktop');
      document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

      if (countContainer){
        countContainer.classList.add('loading');
      }
      if (countContainerDesktop){
        countContainerDesktop.classList.add('loading');
      }

      /* **** cooder improvements *****/
      searchParams = FacetFiltersForm.replaceUrl(searchParams);

      sections.forEach((section) => {
        const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
        const filterDataUrl = element => element.url === url;

        FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
      });

      if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

    }

    static updateActiveFacets() {
      if(document.querySelectorAll('.active-facets__content facet-remove').length) {
        document.body.classList.add('facets-active')

        if(sessionStorage.getItem('searchParams')) {
          document.querySelector('.active-facets__content').style.opacity = '0';

          let searchP = JSON.parse(sessionStorage.getItem('searchParams')).reverse();

          const arr = Array.from(document.querySelectorAll('.active-facets__content facet-remove')).sort(function(a, b){
            let valueA = a.querySelector('a').getAttribute('data-value')
            let valueB = b.querySelector('a').getAttribute('data-value')

            return searchP.indexOf(valueA) - searchP.indexOf(valueB);
          });

          const pageEvent = new CustomEvent("page-update");
          window.dispatchEvent(pageEvent);

          document.querySelector('.active-facets__content').innerHTML = '';

          for (var i = 0; i < arr.length; ++i) {
            document.querySelector('.active-facets__content').appendChild(arr[i]);
          }

          document.querySelector('.active-facets__content').style.opacity = '1';

          const isActive = document.querySelector('.active-facets__content').classList.contains('limited')
          if(!isActive) {
            window.setTimeout(function() {
              document.querySelector('.active-facets__wrapper').classList.add('limited');
            }, 200);
          }
        }

      } else {
        document.body.classList.remove('facets-active')
        sessionStorage.removeItem('searchParams')
        document.querySelector('.active-facets__wrapper')?.classList.remove('limited','expanded');
      }

      let childrenWidth = 0;
      document.querySelectorAll('.active-facets__content facet-remove').forEach(elem => {
        childrenWidth += elem.offsetWidth;
      });

      let maxWrapperWidth = window.innerWidth - 20

      if(window.matchMedia('(min-width: 768px)').matches) {
        maxWrapperWidth = 340
      }

      // Show/hide button expand
      if(childrenWidth >= maxWrapperWidth) {
        document.body.classList.add('expanded')
      } else {
        document.body.classList.remove('expanded')
      }

    }

    /***** cooder improvements *****/
    static replaceUrl(searchParams) {
      if (!searchParams.includes('grupposuper')){
        let NewsearchParams = searchParams.split('&');
        FacetFiltersForm.updateSessionVar(NewsearchParams);
        NewsearchParams = NewsearchParams.filter(item => !item.includes('sub-gruppo'));
        NewsearchParams = NewsearchParams.filter(item => !item.includes('gruppo'));
        searchParams = new URLSearchParams(NewsearchParams.join('&')).toString();
      }

      return searchParams;
    }

    static updateSessionVar(NewsearchParams) {

      let filterValueArr = [];
      let update = false;

      if(NewsearchParams.filter(item => item.includes('sub-gruppo')).length > 0) {
        const subgruppo = NewsearchParams.filter(item => item.includes('sub-gruppo'));
        filterValueArr.push(subgruppo[0].split('=')[1]);
        update = true;
      }
      if(NewsearchParams.filter(item => item.includes('gruppo')).length > 0) {
        const gruppo = NewsearchParams.filter(item => item.includes('gruppo'));
        filterValueArr.push(gruppo[0].split('=')[1]);
        update = true;
      }

      if(update) {
        let sessionArr = JSON.parse(sessionStorage.getItem('searchParams'));

        filterValueArr.forEach(elem => {
          const index = sessionArr.indexOf(elem);

          if (index !== -1) {
              const valueToRemove = [sessionArr[index]];
              sessionArr = sessionArr.filter(element => !valueToRemove.includes(element));
          }
        });

        sessionStorage.removeItem('searchParams');

        if(sessionArr.length > 0) {
          sessionStorage.setItem('searchParams', JSON.stringify(sessionArr));
        }
      }

    }

    /* custom method -> read url and show/hide the filter category (es. show terzo livello when a filter on secondo livello is active) [MC]*/
    static handleFilterCategory(searchParams){
      // document.querySelector("#FacetFiltersFormMobile .mobile-terzolivello").style.display = "none";
      // document.querySelector("#FacetFiltersFormMobile .mobile-quartolivello").style.display = "none";
      // if(searchParams.includes("secondo_livello")){
      //   document.querySelector("#FacetFiltersFormMobile .mobile-terzolivello").style.display = "block";
      // }
      // if(searchParams.includes("terzolivello")){
      //   document.querySelector("#FacetFiltersFormMobile .mobile-quartolivello").style.display = "block";
      // }
      /* TODO mobile */
    }

    static renderSectionFromFetch(url, event) {
      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;

          FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
          FacetFiltersForm.renderFilters(html, event);
          FacetFiltersForm.renderProductGridContainer(html);
          // FacetFiltersForm.renderProductCount(html);
        })
        /* after render filters elements execute custom behaviours [MC]*/
        .then(()=>{
          FacetFiltersForm.handleFilterCategory(window.location.search);
          FacetFiltersForm.updateActiveFacets();
          if (typeof ReloadSmartWishlist !== "undefined" && $.isFunction(ReloadSmartWishlist)) ReloadSmartWishlist();
          const pageEvent = new CustomEvent("page-update");
          window.dispatchEvent(pageEvent);
        })
    }

    static renderSectionFromCache(filterDataUrl, event) {
      const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      FacetFiltersForm.updateActiveFacets();
      if (typeof ReloadSmartWishlist !== "undefined" && $.isFunction(ReloadSmartWishlist)) ReloadSmartWishlist();
      const pageEvent = new CustomEvent("page-update");
      window.dispatchEvent(pageEvent);
      // FacetFiltersForm.renderProductCount(html);
    }

    static renderProductGridContainer(html) {
      document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    }

    static renderProductCount(html) {
      const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
      const container = document.getElementById('ProductCount');
      const containerDesktop = document.getElementById('ProductCountDesktop');
      container.innerHTML = count;
      container.classList.remove('loading');
      if (containerDesktop) {
        containerDesktop.innerHTML = count;
        containerDesktop.classList.remove('loading');
      }
    }

    static renderFilters(html, event) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

      const facetDetailsElements =
        parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
      const matchesIndex = (element) => {
        const jsFilter = event ? event.target.closest('.js-filter') : undefined;
        return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
      }
      const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
      // const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

      facetsToRender.forEach((element) => {
        document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
      });

      FacetFiltersForm.renderActiveFacets(parsedHTML);
      FacetFiltersForm.renderAdditionalElements(parsedHTML);

      /* cooder improve */
      //FacetFiltersForm.renderCustomFilters(parsedHTML);

      //if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
    }

    static renderActiveFacets(html) {
      const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

      activeFacetElementSelectors.forEach((selector) => {
        const activeFacetsElement = html.querySelector(selector);
        if (!activeFacetsElement) return;
        document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
      })

      FacetFiltersForm.toggleActiveFacets(false);
    }

    /* COODER improve */
    // static renderCustomFilters(html) {
    //   const activeFacetElementSelectors = ['.secondo_livello', '.terzolivello'];

    //   /* activeFacetElementSelectors.forEach((selector) => {
    //     const activeFacetsElement = html.querySelector(selector);
    //     if (!activeFacetsElement) return;
    //     document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    //   }) */

    //   activeFacetElementSelectors.forEach((selector) => {
    //     const NewElement = html.querySelector(selector);
    //     const OriginalElement = document.querySelector(selector);
    //     if (!NewElement) return;
    //     OriginalElement.parentNode.replaceChild(NewElement, OriginalElement);
    //   })


    // }

    static renderAdditionalElements(html) {
      const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

      mobileElementSelectors.forEach((selector) => {
        if (!html.querySelector(selector)) return;
        document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
      });

      document.getElementById('FacetFiltersFormMobile').closest('facets-drawer').bindEvents();
    }

    static renderCounts(source, target) {
      const targetElement = target.querySelector('.facets__selected');
      const sourceElement = source.querySelector('.facets__selected');

      const targetElementAccessibility = target.querySelector('.facets__summary');
      const sourceElementAccessibility = source.querySelector('.facets__summary');

      if (sourceElement && targetElement) {
        target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
      }

      if (targetElementAccessibility && sourceElementAccessibility) {
        target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
      }
    }

    static updateURLHash(searchParams) {
      history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    }

    static getSections() {
      return [
        {
          section: document.getElementById('product-grid').dataset.id,
        }
      ]
    }

    createSearchParams(form) {
      const formData = new FormData(form);
      return new URLSearchParams(formData).toString();
    }

    onSubmitForm(searchParams, event) {
      FacetFiltersForm.renderPage(searchParams, event);
    }

    onSubmitHandler(event) {
      event.preventDefault();

      const sortFilterForms = document.querySelectorAll('facet-filters-form form');
      if (event.srcElement.className == 'mobile-facets__checkbox') {

        const searchParams = this.createSearchParams(event.target.closest('form'))
        this.onSubmitForm(searchParams, event)
      } else {
        const forms = [];
        const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

        sortFilterForms.forEach((form) => {
          if (!isMobile) {
            if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
              const noJsElements = document.querySelectorAll('.no-js-list');
              noJsElements.forEach((el) => el.remove());
              forms.push(this.createSearchParams(form));
            }
          } else if (form.id === 'FacetFiltersFormMobile') {
            forms.push(this.createSearchParams(form));
          }
        });
        this.onSubmitForm(forms.join('&'), event)
      }
    }

    onActiveFilterClick(event) {
      event.preventDefault();
      let filterValue = event.target.getAttribute('data-value') ? event.target.getAttribute('data-value') :event.target.parentElement.getAttribute('data-value');
      if( sessionStorage.getItem('searchParams')) {
        if (filterValue != 'remove') {
          let sessionArr = JSON.parse(sessionStorage.getItem('searchParams'));
          let index = sessionArr.indexOf(filterValue);

          if (index !== -1) {
            let valueToRemove = [sessionArr[index]];
            sessionArr = sessionArr.filter(element => !valueToRemove.includes(element));
            sessionStorage.removeItem('searchParams');

            if(sessionArr.length > 0)
                sessionStorage.setItem('searchParams', JSON.stringify(sessionArr));
            }
        } else {
          sessionStorage.removeItem('searchParams');
        }
      }
      FacetFiltersForm.toggleActiveFacets();
      const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
      FacetFiltersForm.renderPage(url);
    }

    /*
    handleBrandSearch(event) {
      let searchValue, filterList, filterListElements;

      searchValue = event.target.value.toLowerCase();
      filterList = event.target.parentElement.nextElementSibling;
      filterListElements = filterList.getElementsByTagName("li");

      Array.from(filterListElements).forEach(li => {
        const span = li.querySelector('label .value');
        li.style.display = span.innerHTML.toLowerCase().indexOf(searchValue) > -1 ? '' : 'none' ;
      });
    }
    */
  }

  FacetFiltersForm.filterData = [];
  FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
  FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
  customElements.define('facet-filters-form', FacetFiltersForm);
  FacetFiltersForm.setListeners();
  FacetFiltersForm.updateActiveFacets();

  class PriceRange extends HTMLElement {
    constructor() {
      super();
      this.querySelectorAll('input')
        .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
      this.setMinAndMaxValues();
    }

    onRangeChange(event) {
      this.adjustToValidValues(event.currentTarget);
      this.setMinAndMaxValues();
    }

    setMinAndMaxValues() {
      const inputs = this.querySelectorAll('input');
      const minInput = inputs[0];
      const maxInput = inputs[1];
      if (maxInput.value) minInput.setAttribute('max', maxInput.value);
      if (minInput.value) maxInput.setAttribute('min', minInput.value);
      if (minInput.value === '') maxInput.setAttribute('min', 0);
      if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
    }

    adjustToValidValues(input) {
      const value = Number(input.value);
      const min = Number(input.getAttribute('min'));
      const max = Number(input.getAttribute('max'));

      if (value < min) input.value = min;
      if (value > max) input.value = max;
    }
  }

  customElements.define('price-range', PriceRange);

  class FacetRemove extends HTMLElement {
    constructor() {
      super();
      const facetLink = this.querySelector('a');
      facetLink.setAttribute('role', 'button');
      facetLink.addEventListener('click', this.closeFilter.bind(this));
      facetLink.addEventListener('keyup', (event) => {
        event.preventDefault();
        if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
      });
    }

    closeFilter(event) {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    }
  }

  customElements.define('facet-remove', FacetRemove);


  class FacetsDrawer extends MenuDrawer {
    constructor() {
      super();
    }

    bindEvents() {
      super.bindEvents()
      this.querySelectorAll('button.close-details').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
      this.querySelectorAll('.close-drawer').forEach(button => button.addEventListener('click', this.onCloseMenuButtonClick.bind(this)));
      document.body.addEventListener('click', (event) => this.onFocusOut.bind(this, event)());
    }

    onFocusOut(event) {
      if (!event.target.contains(this)) return
      setTimeout(() => {
        if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
          this.closeMenuDrawer();
      });
    }


    closeMenuDrawer(event, elementToFocus = false) {
      super.closeMenuDrawer()
      document.body.classList.remove('submenu-open');
    }

    onCloseButtonClick(event) {
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }


    onCloseMenuButtonClick(event) {
      this.closeSubmenu(this.mainDetailsToggle);
      this.onCloseButtonClick(event)
      document.body.classList.remove(`overflow-hidden`);
    }

    closeSubmenu(detailsElement) {
      super.closeSubmenu(detailsElement)
      const formElement = detailsElement.closest('form.submenu-open');
      formElement && formElement.classList.remove('submenu-open');
      document.body.classList.remove('submenu-open');
      this.mainDetailsToggle.classList.remove('opened')
    }
  }

  customElements.define('facets-drawer', FacetsDrawer);
